import { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { subscribeToDiscipline } from "../firebase/services";
import { getPoolAccessPoolId } from "../firebase/accessSessions";
import JudgeScore from "./JudgeScore";
import UnavailableView from "../components/UnavailableView";

export default function JudgePool() {
  const { eventId, disciplineId, poolName } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const judgeName = location.state?.judgeName || localStorage.getItem("judgeName") || "Judge";
  const [disc, setDisc] = useState(null);

  useEffect(() => {
    const unsub = subscribeToDiscipline(eventId, disciplineId, setDisc);
    return unsub;
  }, [eventId, disciplineId]);

  const decodedPoolName = decodeURIComponent(poolName);
  const pool = disc?.pools?.find((p) => p.name === decodedPoolName);
  const accessPoolId = getPoolAccessPoolId(eventId, disciplineId, decodedPoolName);

  if (!disc) return <div className="flex items-center justify-center min-h-screen text-gray-600">Loading...</div>;
  if (!pool || !accessPoolId || pool.id !== accessPoolId || !(pool.judges || []).includes(judgeName)) {
    return <UnavailableView eventId={eventId} title="Pool Access Ended"
      message="The pool was reset or your assignment changed. Enter the current pool code to rejoin, or return to the event page for the current schedule." />;
  }

  if (!pool.activeBoutId) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen p-6 text-center">
        <div className="text-4xl mb-4">⏳</div>
        <h2 className="font-display text-lg font-bold mb-2">Waiting for Ref</h2>
        <p className="text-gray-500 text-sm mb-1">{pool.name}</p>
        <p className="text-gray-600 text-xs mb-6">The ref hasn't started the next bout yet.</p>
        <div className="flex gap-1">
          {[0, 1, 2].map((i) => (
            <div key={i} className="w-1.5 h-1.5 rounded-full bg-yellow-500 pulse-dot" style={{ animationDelay: `${i * 0.2}s` }} />
          ))}
        </div>
        <div className="mt-8 text-gray-600 text-xs">Judging as <span className="text-gray-400">{judgeName}</span></div>
      </div>
    );
  }

  return (
    <JudgeScore
      key={pool.activeBoutId}
      eventId={eventId}
      boutId={pool.activeBoutId}
      judgeName={judgeName}
      onLeave={() => navigate("/judge")}
    />
  );
}
